/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";

const ModuleDefinition = {
  name: "Excluded stay dates",
  entityName: "modificationBookingWindow",
  entities: [],
  renderers: {
    list: {},
    form: {},
  },

  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterOptionTranslations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: false,
  },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
      },
    ],
    form: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
        className: "tickerInput closeButtonInside",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
        className: "tickerInput closeButtonInside",
      },
    ],
  },
  validation: {
    startDate: {
      type: "Date",
      constraints: {
        presence: {
          allowEmpty: false,
        },
        compare: {
          logic: "isLesser",
          than: ["endDate"],
          message: "^The end date must be greater than the start date.",
          valueType: "date",
        },
      },
      relatedFields: ["endDate"],
    },
    endDate: {
      type: "Date",
      constraints: {
        presence: {
          allowEmpty: false,
        },
        compare: {
          logic: "isGreater",
          than: ["startDate"],
          message: "^The end date must be greater than the start date.",
          valueType: "date",
        },
      },
      relatedFields: ["startDate"],
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
